import { render, staticRenderFns } from "./create-tag-search.vue?vue&type=template&id=0d984c6b"
import script from "./create-tag-search.vue?vue&type=script&lang=js"
export * from "./create-tag-search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports